<template>
  <div class="pa-2 flex flex-col space-y-2.5">
    <view-receive-transfer-inventory ref="viewReceiveTransferInventoryRef" @save-success="getReceiveTransferInventory">

    </view-receive-transfer-inventory>
    <v-card outlined class="ma-0" v-if="authPermissions.has('store_receives:view')">
      <div>
        <v-data-table :headers="headers" dense :loading="gettingReceiveInventory" :items="items">
          <template #item._action="{ item }">
            <v-btn v-if="authPermissions.has('store_receives:edit')" dense
              :color="item.unsavedChanges ? 'warning' : 'primary'" small class="ma-0"
              @click="() => $refs.viewReceiveTransferInventoryRef.openDialog(item.id)">view</v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>
<style></style>
<script>
import axios from '@/extra-functions/axios.extra'
import { mapState } from 'vuex'
import LocalStore from '../../../lib/localStore'

export default {
  name: 'ReceiveTransferInventory',
  components: {
    viewReceiveTransferInventory: () => import('@/views/dashboard/components/receive-transfer-inventories/ViewReceiveTransferInventory'),
  },
  data() {
    return {
      headers: [
        { value: 'receipt_no', text: 'Receipt No.' },
        { value: 'date', text: 'Date' },
        { value: 'received_by', text: 'Received By' },
        { value: 'from_store.name', text: 'From' },
        { value: '', text: 'Area Code' },
        { value: 'status', text: 'Status' },
        { value: '_action' },
      ],
      items: [],
      gettingReceiveInventory: false,
    }
  },
  computed: {
    ...mapState({
      currentStoreId: state => state.settings.storeId,
      token: state => state.auth.token,
      receiveUnsavedChanges: state => state.appDrawer.receive.unsavedChanges,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  created() {
    this.getReceiveTransferInventory()
  },
  watch: {
    receiveUnsavedChanges() {
      const localStore = new LocalStore()
      const localData = localStore.get('viewReceiveTransferInventoryUnsavedChanges')
      this.items = this.items.map(item => {
        return { ...item, unsavedChanges: !!localData?.[item.id] }
      })
    },
  },
  methods: {
    async getReceiveTransferInventory() {
      try {
        if (this.gettingReceiveInventory) return
        this.gettingReceiveInventory = true
        const { data } = await axios(this.token).get('/store-receives')
        const localStore = new LocalStore()
        const localData = localStore.get('viewReceiveTransferInventory')
        this.items = data.map(item => {
          return { ...item, unsavedChanges: !!localData?.[item.id] }
        })
      } catch (e) {
        ; (function () {
          if (process.env.production === true) {
            this.$alertSwalError('oops something went wrong retrying in 3secs...')
            return
          }
          this.$alertSwalError(e.message)
        }.bind(this))()
        setTimeout(() => {
          this.getReceiveTransferInventory()
        }, 3000)
      } finally {
        this.gettingReceiveInventory = false
      }
    },
  },
}
</script>
